// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../wallpaper/mb-gt-amg-land-big.jpg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "body{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}form.ui.custom-ui.form .ui.button{border:1px solid green;background:green none}.ciam-titlebar{background-color:#0f0}@media (min-width:666px){.ciam-footer{background-color:#0f0}}", ""]);
// Exports
module.exports = exports;
